<template>
  <div class="player">
    <div class="control">
      <img
        class="play-button"
        :src="`/img/common/${ buttonImage }`"
        @click.prevent="togglePlay" />
    </div>
    <div class="seekbar">
      <vue-slider
        v-model="position"
        :disabled="!audioPlayer"
        :process-style="{ 'background-color': '#ff6c00' }"
        tooltip="none"
        @change="onPositionChanged" />
    </div>
    <div class="time">
      {{ currentTimeString }} / {{ durationString }}
    </div>
  </div>
</template>

<script>
import { Howl } from 'howler'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { getPreSignedUrl } from '../../logic/url'

export default {
  name: 'AudioPlayer',

  components: {
    VueSlider,
  },
  props: {
    url: {
      type: String,
      required: false,
      default: '',
    },
    durationString: {
      type: String,
      required: false,
      default: '',
    },
    currentPlayUrl: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      duration: 0,
      currentTime: 0,
      playing: false,
      loading: false,
      position: 0,
      audioPlayer: null,
      playTimer: null,
    }
  },
  computed: {
    currentTimeString() {
      const min = `00${Math.floor(this.currentTime / 60)}`.slice(-2)
      const sec = `00${Math.floor(this.currentTime % 60)}`.slice(-2)
      return `00:${min}:${sec}`
    },
    buttonImage() {
      if (this.loading) return 'spinner.gif'
      if (this.playing) return 'pause.png'
      return 'play.png'
    },
  },
  watch: {
    url() {
      if (this.url && this.audioPlayer) {
        this.audioPlayer.pause()
      }
    },
    currentPlayUrl() {
      if (this.audioPlayer && this.url !== this.currentPlayUrl) {
        this.audioPlayer.pause()
      }
    },
  },
  destroyed() {
    if (this.playTimer) {
      clearTimeout(this.playTimer)
    }
    if (this.audioPlayer) {
      this.audioPlayer.pause()
      this.audioPlayer = null
    }
  },
  mounted() {
  },
  methods: {
    updateTimer() {
      if (!this.audioPlayer) {
        this.togglePlay()
        return
      }
      this.duration = this.audioPlayer.duration()
      this.currentTime = this.audioPlayer.seek()
      this.$emit('timeupdate', this.currentTime)
      const position = (this.currentTime / this.duration) * 100
      this.position = !Number.isNaN(position) ? position : 0
    },
    async togglePlay() {
      if (this.playTimer) {
        clearTimeout(this.playTimer)
      }
      if (this.playing) {
        this.audioPlayer.pause()
      } else if (!this.audioPlayer) {
        this.loading = true

        const audioUrl = await getPreSignedUrl(this.url)
        const howl = new Howl({
          src: [audioUrl],
          html5: true,
        })
        this.audioPlayer = howl

        // コンポーネントが破棄される、または再生対象が切り替わった後にロード完了した場合は何もしない
        howl.once('load', () => {
          if (this.audioPlayer !== howl) {
            return
          }
          if (this.position > 0) {
            howl.seek(howl.duration() * (this.position / 100))
          }
          howl.play()
          this.loading = false
        })
        howl.on('play', () => {
          if (this.audioPlayer !== howl) {
            return
          }
          this.playing = true
          this.playTimer = setInterval(this.updateTimer, 500)
        })
        howl.on('pause', () => {
          if (this.audioPlayer !== howl) {
            return
          }
          this.playing = false
        })
        howl.on('end', () => {
          if (this.audioPlayer !== howl) {
            return
          }
          clearInterval(this.playTimer)
          setTimeout(() => {
            this.playing = false
            this.currentTime = 0
            this.position = 0
          }, 700)
        })
        this.$emit('play-start', this.url, howl)
      } else {
        this.audioPlayer.play()
        this.$emit('play-start', this.url, this.audioPlayer)
      }
    },
    onPositionChanged(position) {
      if (!this.audioPlayer) {
        this.togglePlay()
        return
      }
      this.audioPlayer.seek(this.audioPlayer.duration() * (position / 100))
    },
  },
}
</script>

<style scoped>
.player {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.control {
}
.seekbar {
  flex-grow: 1;
  margin-left: 8px;
  margin-right: 8px;
}
.time {
  font-family: monospace, monospace;
  margin-right: 8px;
  color: #323232;
  font-size: 12px;
}
.play-button {
  width: 22px;
  height: 22px;
  cursor: pointer;
  margin: 5px;
}
</style>
